import exploreImg from '../layout2.0/images/icons/ico_explore.svg'
import myStayImg from '../layout2.0/images/icons/ico_my_stay.svg'
import notifictionImg from '../layout2.0/images/icons/ico_notify.svg'
import SquareLargeWidget from '../UI/widgetDisplayTypes/squareLargeWidget'
import SingleSqureSmall from '../UI/widgetDisplayTypes/singleSqureSmall'
import HorizontalSingleSmallWidget from '../UI/widgetDisplayTypes/horizontalSingleSmallWidget'
import HorizontalDoubleSmallWidget from '../UI/widgetDisplayTypes/horizontalDoubleSmallWidget'
import HorizontalDoubleLargeWidget from '../UI/widgetDisplayTypes/horizontalDoubleLargeWidget'
import HorizontalMultipleLargeWidget from '../UI/widgetDisplayTypes/horizontalMultipleLargeWidget'
import SquareMultipleSmallWidget from '../UI/widgetDisplayTypes/squareMultipleSmallWidget'
import GuestItineraryHomepage from '../UI/widgetDisplayTypes/guestItineraryHomepage'
import weatherWidget from '../UI/widgetDisplayTypes/weatherWidget'
import homescreenIframeRenderer from '../UI/widgetDisplayTypes/homescreenIframeRenderer'
import clockWidget from '../UI/widgetDisplayTypes/clockWidget'
import { TEMP_SPA_WIDGET_ACT_AS_FIND_YOUR_STAY_NON_THE_KNOW_MEMBERS } from './constant'
import TripPlannerHomePage from '../layout2.0/components/tripPlanner/tripPlannerHome'
import multiControllerWidget from '../UI/widgetDisplayTypes/multiControllerWidget'
import InfoPageScrollCarouselWidget from '../UI/widgetDisplayTypes/infoPageScrollCarouselWidget'


export const homeNaviation = [
    {
        path: "/explore",
        label: "EXPLORE",
        displayName: "Explore",
        compImage: 'explore'
    },
    {
        path: "/mystay",
        label: "MYSTAY",
        displayName: "My Stay",
        compImage: "myStay"
    },
    {
        path: "/notifications",
        label: "NOTIFICATIONS",
        displayName: "Notifications",
        compImage: "notifiction"
    }
]

export const notificationKeys = [
    "notification",
    "notifications",
];

export const locationSelectorWidget = [
    "location",
    "locations"
]

export const theKnowKeys =[
    'theKnow',
    "the know",
    "profile"
]

export const myTripsKeys =[

    "mytrips",
    "My Trips"
]

export const bookVirginListAtTabClickKeys = [
    'bookvirgin',
    'book'
]

export const musicWidgetTypes = [
    "music",
    "musics"
]


export const chatKeys = [
    "chat",
    "chats",
    "messages",
    "messaging",
]

export const doorkeyKeys = [
    "door key",
    "doorkey",
    "door",
    "key",
    "unlock door",
    'unlockdoor'
]

export const widgetDisplayType = [
    {
        type: "Info Widget Type",
        CompName: SquareLargeWidget
    },
    // {
    //     type: "Small Icon Widget Type",
    //     CompName: SingleSqureSmall
    // },
    {
        type: "Banner Widget Type",
        CompName: HorizontalSingleSmallWidget
    },
    {
        type: "Small Icon Widget Type",
        CompName: HorizontalDoubleSmallWidget
    },
    {
        type: "Half Icon Widget Type",
        CompName: HorizontalDoubleLargeWidget
    },
    {
        type: "Info Scroll Widget Type",
        CompName: HorizontalMultipleLargeWidget
    },
    {
        type: "Small Icon Scroll Widget Type",
        CompName: SquareMultipleSmallWidget
    },
    {
        type: "Guest Itinerary",
        CompName: GuestItineraryHomepage
    },
    {
        type: "Weather",
        CompName: weatherWidget
    },
    {
        type: "URL iFrame Renderer (Open Default)",
        CompName: homescreenIframeRenderer
    },
    {
        type: "Trip Planner (Open default)",
        CompName: TripPlannerHomePage
    },
    {
        type: "Clock",
        CompName: clockWidget
    },
    {
        type: "Multi Controller - Room Wise (Open Default)",
        CompName: multiControllerWidget
    },
    {
        type: "Info Page Scroll Widget",
        CompName: InfoPageScrollCarouselWidget
    },
]

export const navItemsConstant = [
    {
      compName: "Listen to Music",
      alterNativeName: [
        "music",
        "listen"
      ],
      path: "/music",
      image: null
    },
    {
        compName: "Weather",
        alterNativeName: [
          "weather",
        ],
        path: "",
        image: null
      },
    {
        compName: "Activities",
        alterNativeName: [
            "activities",
            "activity"
        ],
        path: "/activities",
        image: null
    },
    {
      compName: "Gallery App",
      alterNativeName: [
        "gallery app",
        "gallery app"
      ],
      path: "/gallery",
      image: ""
    },
    {
        compName: "Tv-Control",
        alterNativeName: [
            "tv control",
            "epg-iptv",
            "epg",
            "iptv"
        ],
        path: "/TVControl2",
        image: null
    },
    {
        compName: "Mobile TV",
        alterNativeName: [
            "mobile tv",
        ],
        path: "/mobileTv",
        image: null
    },
    {
        compName: "Happy",
        alterNativeName: [
            "happy",
        ],
        path: "/happy",
        image: null
    },
    {
        compName: "Room Control",
        alterNativeName: [
            "room control",
            "control"
        ],
        path: "/RoomControl2",
        image: null
    },
    {
        compName: "Hotel Guide",
        alterNativeName: [
            "hotel guide",
            "hotelguide"
        ],
        path: "",
        image: null
    },
    {
        compName: "Mobile Check-in",
        alterNativeName: [
            "Mobile Check-in",
            "mobile check-in",
        ],
        path: "/checkin/id",
        image: null
    }, 
    {
        compName: "Pre Check-in",
        alterNativeName: [
            "pre check-in",
            "pre checkin",
        ],
        path: "/checkin/id",
        image: null
    },
    {
        compName: "Hotel Selector",
        alterNativeName: [
            "hotel selector",
            "hotelselector",
        ],
        path: "/selectHotel",
        image: null
    },
    {
        compName: "Url Renderer",
        alterNativeName: [
            "URL Renderer – Logged in",
            "url renderer – logged in",
        ],
        path: "",
        image: null
    },
    {
        compName: "Multi Controller - Room Wise (Open Default)",
        alterNativeName: [
            "multi controller - room wise (open default)"
        ],
        path: "",
        image: null
    },
    // {
    //   compName: "Movies",
    //   alterNativeName: [
    //     "movies",
    //     "movie"],
    //   path: "/movies",
    //   image: null
    // },
    // {
    //   compName: "Cheval Blanc VOD",
    //   alterNativeName: [
    //     "video on demand",
    //     "vod"
    //   ],
    //   path: "/vod",
    //   image: null
    // },
    // {
    //   compName: "Butler Services",
    //   alterNativeName: [
    //     "room-assistance"
    //   ],
    //   path: null
    // },
    {
      compName: "App Launcher",
      alterNativeName: [
        "applauncher",
        "applauncher2",
        "applauncher3",
        "applauncher4",
        "applauncher5",
        "youtube",
        "chrome",
        "launcher",
        "app launcher",
        "crestron",
        "room cantrol"
      ],
      path: "",
      image: null
    },
    {
      compName: "Url Renderer",
      alterNativeName: [
        "url renderer",
        "urlrenderer"
      ],
      path: "",
      image: null
    },
    // {
    //   compName: "Hotel Guide",
    //   alterNativeName: [
    //     "hotel guide",
    //     "hotelguide"
    //   ],
    //   path: "",
    //   image: null
    // },
    {
        compName: "Guest Requests",
        alterNativeName: [
            "guest request",
            "guest requests"
        ],
        path: "/GuestRequest2",
        image: null
    },
    {
        compName: "Grouped Service Requests",
        alterNativeName: [
            "grouped service requests"
        ],
        path: "/GuestRequest2",
        image: null
    },
    {
        compName: "URL iFrame Renderer",
        alterNativeName: [
            "url iframe renderer",
            "URL Iframe Renderer"
        ],
        path: "/iframe-Renderer",
        image: null
    },
    {
        compName: "URL iFrame Renderer (Open Default)",
        alterNativeName: [
            "url iframe renderer (open default)",
        ],
        path: "",
        image: null
    },
    {
        compName: "Trip Planner",
        alterNativeName: [
            "trip planner",
            "trip-planner",
        ],
        path: "/tripPlanner",
        image: null
    },
    {
        compName: "Trip Planner (Open Default)",
        alterNativeName: [
            "trip planner (open default)",
        ],
        path: "",
        image: null
    },
    {
        compName: "eTip",
        alterNativeName: [
            "etip",
            "e-tip",
            "e tip",
        ],
        path: "",
        image: null
    },
    {
        compName: "Upsell",
        alterNativeName: [
            "upsell",
        ],
        path: "/upsells",
        image: null
    },
    {
        compName: "Rewards Program",
        alterNativeName: [
            "rewards program",
            "reward programs",
        ],
        path: "/loyalty",
        image: null
    },
    {
        compName: "The Know",
        alterNativeName: [
            "the know",
            "join the know",
        ],
        path: "/theKnow",
        image: null
    },
    {
        compName: "The Know(Join The Know)",
        alterNativeName: [
            "the know(join the know)"
        ],
        path: "/theKnow",
        image: null
    },
    {
        compName: "The Know(Already Joined)",
        alterNativeName: [
            "the know(already joined)"
        ],
        path: "",
        image: null
    },
    {
        compName: "Sign Up(The Know)",
        alterNativeName: [
            "sign up(the know)"
        ],
        path: "/theKnow",
        image: null
    },
    {
        compName: "View My Bill",
        alterNativeName: [
            "view my bill",
            "view bill"
        ],
        path: "/viewBill2",
        image: null
    },
    {
        compName: "Spa Location",
        alterNativeName: [
            "spa",
            "spa location",
            "spa_location",
            "spa booking",
        ],
        path:  TEMP_SPA_WIDGET_ACT_AS_FIND_YOUR_STAY_NON_THE_KNOW_MEMBERS ? "/find-stay-non-theknow-members": "/spaBooking2",
        image: null
    },
    {
        compName: "Activities - Book4Time",
        alterNativeName: [
            "activities - book4time",
            "activities location - book4time",
        ],
        path: "/activityBooking",
        image: null
    },
    {
        compName: "way activity",
        alterNativeName: [
            "way-activity",
            "Way-Activity",
            "Way Activity"
        ],
        path: "/way-activity",
        image: null
    },
    {
            compName: "Events Location - 7 Rooms",
            alterNativeName: [
                "events location - 7 rooms",
                "Events - 7Rooms",
                "events - 7rooms"
            ],
            path: "/eventsBooking",
            image: null
    },
    {
        compName: "Room service",
        alterNativeName: [
            "h-commerce",
            "hcommerce",

        ],
        path: "/hcommerce2",
        image: null
    },
    {
        compName: "Guest Itinerary",
        alterNativeName: [
            "guest itinerary",
            "guest_itinerary",
        ],
        path: "/myReservations",
        image: null
    },
    {
        compName: "Door Camera",
        alterNativeName: [
            "Door Camera Feed",
            'door camera',
        ],
        path: "",
        image: null
    },
   /* {
        compName: "Room service",
        alterNativeName: [
            "Mobile Check-in",
            "mobile check-in",
        ],
        path: "",
        image: null
    }, */
    {
        compName: "Room Theme",
        alterNativeName: [
            "Room Theme",
            'room theme',
        ],
        path: "/RoomControl2",
        image: null
    },
    {
        compName: "Multi Controller",
        alterNativeName: [
            "Multi-Controller",
            'multi-controller',
        ],
        path: "/RoomControl2",
        image: null
    },
    {
        compName: "Smart Window Control",
        alterNativeName: [
            "Smart Window Control",
            'smart window control',
        ],
        path: "/RoomControl2",
        image: null
    },
    {
        compName: "Room Temperature Control",
        alterNativeName: [
            "Room Temperature Control ",
            'room temperature',
        ],
        path: "/RoomControl2",
        image: null
    },
    {
        compName: "TV Lift Control",
        alterNativeName: [
            "TV Lift Control ",
            'tv lift control',
        ],
        path: "/TVLift",
        image: null
    },
    {
        compName: "DND",
        alterNativeName: [
            "DND",
            'dnd',
        ],
        path: "",
        image: null
    },
    {
        compName: "Door Unlock",
        alterNativeName: [
            "Door Unlock",
            'door unlock',
        ],
        path: "",
        image: null
    },
    {
        compName: "Url Renderer",
        alterNativeName: [
            "URL Renderer",
            "url renderer",
        ],
        path: "",
        image: null
    },
    {
        compName: "RealTime Booking",
        alterNativeName: [
            "realtime booking",
            "realTime Booking",
            "Realtime Booking",
            "realtime booking"
        ],
        path:"",
        image: null
    },
    {
        compName: "SMS Message",
        alterNativeName: [
            "SMS Message",
            "sms message",
            "Sms Message",
            "SMS Widget"
        ],
        path:"",
        image: null
    },
    {
        compName: "Guest Details",
        alterNativeName: [
            "guest details",
            "guestdetails"
        ],
        path: "",
        image: null
    },
    {
        compName: "Restaurant Reservation",
        alterNativeName: [
            "restaurant reservation",
            "Restaurant reservation",
        ],
        path:"/resReservation",
        image: null
    },
    {
        compName: "MUR",
        alterNativeName: [
            "MUR",
            'mur',
        ],
        path: "",
        image: null
    },
    {
        compName: "Speaker",
        alterNativeName: [
            "Speaker",
            'speaker',
        ],
        path: "/RoomControl2",
        image: null
    },{
        compName: "FAQ",
        alterNativeName: [
            "faq",
            'Frequently Asked Questions',
            "FAQ"
        ],
        image: null
    },{
        compName: "Privacy Policy",
        alterNativeName: [
            "privacypolicy",
            'privacy policy',
        ],
        image: null
    },{
        compName: "Language",
        alterNativeName: [
            "language",
            'Language',
        ],
        image: null
    },{
        compName: "Terms and Condition",
        alterNativeName: [
            "Terms and Conditions",
            'terms and condition',
        ],
        image: null
    },
    {
        compName: "Find My Stay (Non TheKnow Members)",
        alterNativeName: [
            "find my stay (non theknow members)"
        ],
        path: "/find-stay-non-theknow-members",
        image: null
    },

    // {
    //   compName: "Door Camera",
    //   alterNativeName: [
    //     "door camera feed",
    //     "camerastream",
    //     "camera"
    //   ],
    //   path: "",
    //   image: null
    // }
    /*
    {
      alterNativeName: "icon4-error.png",
      path: "/error"
    },
    {
      alterNativeName: "ico4-rate.png",
      className: "rate",
      path: "/rate"
    }*/
]


export const ActivityList = [
    {
        heading: "Hotel Gym",
        disc: "Available 06:00 - 23:00"
    },
    {
        heading: "Hotel Gym",
        disc: "Available 06:00 - 23:00"
    },
    {
        heading: "Hotel Gym",
        disc: "Available 06:00 - 23:00"
    },
    {
        heading: "Hotel Gym",
        disc: "Available 06:00 - 23:00"
    },
    {
        heading: "Hotel Gym",
        disc: "Available 06:00 - 23:00"
    },
    {
        heading: "Hotel Gym",
        disc: "Available 06:00 - 23:00"
    },
    {
        heading: "Hotel Gym",
        disc: "Available 06:00 - 23:00"
    },
    {
        heading: "Hotel Gym",
        disc: "Available 06:00 - 23:00"
    },
    {
        heading: "Hotel Gym",
        disc: "Available 06:00 - 23:00"
    },
    {
        heading: "Hotel Gym",
        disc: "Available 06:00 - 23:00"
    }
]

